import { RouterTransitionEnum } from '@/enums/appEnum';
import {
  MenuModeEnum,
  MenuTypeEnum,
  MixSidebarTriggerEnum,
} from '@/enums/menuEnum';

import { useI18n } from '@/hooks/web/useI18n';

const { t } = useI18n()

export enum HandlerEnum {
  CHANGE_LAYOUT,
  CHANGE_THEME_COLOR,
  CHANGE_THEME,
  // menu
  MENU_HAS_DRAG,
  MENU_ACCORDION,
  MENU_TRIGGER,
  MENU_TOP_ALIGN,
  MENU_COLLAPSED,
  MENU_COLLAPSED_SHOW_TITLE,
  MENU_WIDTH,
  MENU_SHOW_SIDEBAR,
  MENU_THEME,
  MENU_SPLIT,
  MENU_FIXED,
  MENU_CLOSE_MIX_SIDEBAR_ON_CHANGE,
  MENU_TRIGGER_MIX_SIDEBAR,
  MENU_FIXED_MIX_SIDEBAR,

  // header
  BASE_BORDER_RADUIS_SET,
  BASE_FONT_SIZE_SET,
  BASE_SPACE,
  HEADER_SHOW,
  HEADER_THEME,
  HEADER_RIGHT_TOOLS_EDITOR,
  HEADER_ICON_THEME,
  HEADER_FIXED,
  HEADER_NOTICE,
  HEADER_SYSTEM_TITLE,
  HEADER_BIG_SCREEN,
  HEADER_HELP_ICON_SCREEN,
  HEADER_SEARCH,
  HEADER_SHOW_APP,
  HEADER_CALLING_SHOW,
  HEADER_KEEP_ALIVE,

  TABS_SHOW_QUICK,
  TABS_SHOW_REDO,
  TABS_SHOW,
  TABS_THEME,
  TABS_SHOW_FOLD,

  LOCK_TIME,
  FULL_CONTENT,
  CONTENT_MODE,
  SHOW_BREADCRUMB,
  SHOW_BREADCRUMB_ICON,
  GRAY_MODE,
  COLOR_WEAK,
  SHOW_LOGO,
  SHOW_FOOTER,

  ROUTER_TRANSITION,
  OPEN_PROGRESS,
  OPEN_PAGE_LOADING,
  OPEN_ROUTE_TRANSITION,

  BACK_GROUND_COLOR_THEME,
  BACK_GROUND_SHOW_TYPE,
  BACK_GROUND_IMG_SRC,
  BACK_FILTER_VAL,
  BACK_OPACITY_VAL,
  BACK_MASK_COLOR,


  USE_DEF_LAYOUT,
  QUICK_MENU_SHOW,

  MENU_QUERY,
  MENU_COLLECT,
  MENU_OPEN_MORE,
  MENU_BG_IMG,
  MENU_BG_IMG_RED,

  MENU_WIDTH_LEFT,
  NOT_SHOW_APP_MENU,
  MENU_EXTEND_THEME
}




export const routerTransitionOptions = [
  RouterTransitionEnum.ZOOM_FADE,
  RouterTransitionEnum.FADE,
  RouterTransitionEnum.ZOOM_OUT,
  RouterTransitionEnum.FADE_SIDE,
  RouterTransitionEnum.FADE_BOTTOM,
  RouterTransitionEnum.FADE_SCALE,
].map((item) => {
  return {
    label: item,
    value: item,
  };
});

export const menuTypeList = [
  {
    title: t('layout.setting.menuTypeSidebar'),
    mode: MenuModeEnum.INLINE,
    type: MenuTypeEnum.SIDEBAR,
  },
  {
    title: t('layout.setting.menuTypeMix'),
    mode: MenuModeEnum.INLINE,
    type: MenuTypeEnum.MIX,
  },

  {
    title: t('layout.setting.menuTypeTopMenu'),
    mode: MenuModeEnum.HORIZONTAL,
    type: MenuTypeEnum.TOP_MENU,
  },
  {
    title: t('layout.setting.menuTypeMixSidebar'),
    mode: MenuModeEnum.INLINE,
    type: MenuTypeEnum.MIX_SIDEBAR,
  },
];

export const mixSidebarTriggerOptions = [
  {
    value: MixSidebarTriggerEnum.HOVER,
    label: t('layout.setting.triggerHover'),
  },
  {
    value: MixSidebarTriggerEnum.CLICK,
    label: t('layout.setting.triggerClick'),
  },
];
